import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const Hba1cInputHistoryPage = lazy(() => import("./Hba1cInputHistoryPage"));

const Hba1cInputHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <Hba1cInputHistoryPage />
    </Suspense>
  );
};

export default Hba1cInputHistoryPageLazy;
